import { getAllDays, getAllMonths, getYears } from 'components/FormCreatorComponent/helpers';
import {
	fieldMode,
	fieldType,
	fieldsGroupType,
	createFormProps,
	validationTypes,
	formThemes,
} from 'components/FormCreatorComponent/types';
import { ContactLegalStatus } from 'constants/global.constants';
import { pendingRequestsTypes } from 'constants/requests.constants';
import { timing } from 'constants/ui.constants';
import { countryId } from 'constants/user.constants';
import { format, isValid } from 'date-fns';

export interface formConfig {
	[key: string]: createFormProps[];
}

export const overrideFormsToCreate = {
	[pendingRequestsTypes.BALANCES]: [
		{
			//name: 'page.pendingRequests.balance.field.requester',
			//handleChange: () => {},
			fieldsGroups: [
				{
					//type: fieldsGroupType.col,
					fields: [
						{
							//type: fieldType.select,
							//mode: fieldMode.readonly,
							props: {
								name: 'approvedBy.id',
								// label: 'page.pendingRequests.balance.field.requester',
								// options: [{ label: 'aaa', value: 'bbb' }],
								// required: true,
								disabled: false,
							},
							validation: [{ requierd: true }],
						},
					],
				},
			],
		},
		{
			name: 'page.pendingRequests.balance.field.bankAccount',
			//handleChange: () => {},
			fieldsGroups: [
				{
					//type: fieldsGroupType.col,
					fields: [
						{
							//type: fieldType.custom,
							//mode: fieldMode.readonly,
							props: {
								name: 'bankAccount.id',
								//label: 'page.pendingRequests.balance.field.bankAccount.description',
								//required: true,
								disabled: false,
								//customComponent: BankAccountsDetails,
								// customData: {
								// 	accounts: [
								// 		{
								// 			id: 1,
								// 			companyId: 1,
								// 			accountOwnerName: 'Uzi Shalom',
								// 			reference: 'iuiuiu',
								// 			bankOrigin: 'aaaaaa',
								// 			bankBranch: 'branch me',
								// 			accountNumber: '426144',
								// 			bankName: {
								// 				bankName: 'eumi',
								// 			},
								// 			currencyId: 16,
								// 		},
								// 	],
								// 	handleBankPick: () => {},
								// 	selectedAccountId: null,
								// },
							},
							validation: [{ requierd: true }],
						},
					],
				},
			],
		},
		{
			name: 'page.pendingRequests.balance.field.altshulerBankAccount',
			//handleChange: () => {},
			fieldsGroups: [
				{
					//type: fieldsGroupType.col,
					fields: [
						{
							// 	type: fieldType.custom,
							// 	mode: fieldMode.readonly,
							props: {
								name: 'altshulerAccountId',
								// 		label: 'page.pendingRequests.balance.field.altshulerBankAccount.description',
								// 		required: true,
								disabled: false,
								// 		customComponent: BankAccountsDetails,
								// 		customData: {
								// 			accounts: [
								// 				{
								// 					id: 1,
								// 					companyId: 1,
								// 					accountOwnerName: 'Uzi Shalom',
								// 					reference: 'iuiuiu',
								// 					bankOrigin: 'aaaaaa',
								// 					bankBranch: 'branch me',
								// 					accountNumber: '426144',
								// 					bankName: {
								// 						bankName: 'eumi',
								// 					},
								// 					currencyId: 16,
								// 				},
								// 			],
								// 			handleBankPick: () => {},
								// 			selectedAccountId: null,
								// 		},
							},
							// 	validation: [{ requierd: true }],
						},
					],
				},
			],
		},
		{
			name: 'page.pendingRequests.balance.field.transferDetails',
			//handleChange: () => {},
			fieldsGroups: [
				{
					//type: fieldsGroupType.col,
					fields: [
						{
							// type: fieldType.text,
							// mode: fieldMode.readonly,
							props: {
								name: 'createdAt',
								// label: 'page.pendingRequests.balance.field.createdAt',
								//required: false,
								// disabled: true,
							},
							//validation: [{ requierd: false }],
							//customValue: (value: any) => value,
						},
						{
							// 	type: fieldType.select,
							// 	mode: fieldMode.readonly,
							props: {
								name: 'currencyId',
								// 		label: 'page.pendingRequests.balance.field.currency',
								// 		options: [{ label: 'bbbb', value: 'cccc' }],
								// 		required: true,
								// 		disabled: false,
							},
							// 	validation: [{ requierd: true }],
						},
						{
							// type: fieldType.text,
							// mode: fieldMode.readWithEnableWrite,
							props: {
								name: 'amount',
								// label: 'page.pendingRequests.balance.field.amount',
								// required: true,
								disabled: false,
							},
							validation: [{ requierd: true }, { integer: true }],
						},
						{
							type: fieldType.file,
							mode: fieldMode.readWithEnableWrite,
							props: {
								name: 'file',
								label: 'page.pendingRequests.field.fileReference',
								required: true,
								disabled: false,
							},
							validation: [{ requierd: true }],
						},
						// {
						// 	// 	type: fieldType.checkbox,
						// 	// 	props: {
						// 	// 		name: 'houseAccountTransferCheck',
						// 	// 		label: 'page.pendingRequests.balance.field.houseAccountTransfer',
						// 	// 		required: false,
						// 	// 		disabled: false,
						// 	// 	},
						// 	// 	validation: [{ checked: true }],
						// },
						{
							// 	type: fieldType.text,
							// 	mode: fieldMode.readWithEnableWrite,
							// 	props: {
							// 		name: 'houseAccountTransferReference',
							// 		label: 'page.pendingRequests.balance.field.reference',
							// 		required: false,
							// 		disabled: false,
							// 	},
							// 	validation: [{ requierd: false }],
						},
					],
				},
			],
		},
		{
			name: 'page.pendingRequests.balance.field.companyManagement',
			hide: true,
			handleChange: () => {},
			fieldsGroups: [
				{
					type: fieldsGroupType.col,
					fields: [
						{
							//type: fieldType.text,
							//mode: fieldMode.readonly,
							props: {
								name: 'company.manager.name',
								// label: 'page.pendingRequests.balance.field.requester.company.manager',
								// required: false,
								// disabled: true,
							},
							validation: [{}],
						},
					],
				},
			],
		},
		{
			name: 'page.pendingRequests.balance.field.firstBoSigner',
			//hide: true,
			//handleChange: () => {},
			fieldsGroups: [
				{
					type: fieldsGroupType.col,
					fields: [
						{
							//type: fieldType.text,
							//mode: fieldMode.readonly,
							props: {
								name: 'boFirstBoSignerApprovedByUserName',
								//label: 'page.pendingRequests.balance.field.bo.signer.approval.name',
								required: false,
								//disabled: true,
							},
							//validation: [],
						},
					],
				},
			],
		},

		{
			name: 'page.pendingRequests.balance.field.confirm.mainTitle',
			//handleChange: () => {},
			fieldsGroups: [
				{
					//type: fieldsGroupType.col,
					fields: [
						// {
						// 	type: fieldType.checkbox,
						// 	props: {
						// 		name: 'approveTitle',
						// 		label: 'page.pendingRequests.balance.field.confirm.title',
						// 		required: false,
						// 		disabled: false,
						// 	},
						// 	validation: [{ checked: true }],
						// },
						// {
						// 	type: fieldType.label,
						// 	mode: fieldMode.readWithEnableWrite,
						// 	props: {
						// 		name: 'approveSubTitle',
						// 		label: 'page.pendingRequests.balance.field.confirm.subtitle',
						// 		required: false,
						// 		disabled: false,
						// 	},
						// 	validation: [{ requierd: false }],
						// },
					],
				},
			],
		},
	],
	[pendingRequestsTypes.CONTACTS]: [
		{
			name: 'page.managePendingRequests.forms.account',
			handleChange: () => {},
			fieldsGroups: [
				{
					type: fieldsGroupType.col,
					fields: [
						{
							type: fieldType.text,
							mode: fieldMode.readonly,
							props: {
								name: 'firstNameHebrew',
								label: 'label.firstNameHebrew',
								required: true,
								disabled: false,
							},
							validation: [{ requierd: true }, { [validationTypes.hebrewLettersOnly]: true }],
						},
						{
							type: fieldType.text,
							mode: fieldMode.readonly,
							props: {
								name: 'lastNameHebrew',
								label: 'label.lastNameHebrew',
								required: true,
								disabled: false,
							},
							validation: [{ requierd: true }, { [validationTypes.hebrewLettersOnly]: true }],
						},
						{
							type: fieldType.text,
							mode: fieldMode.readonly,
							props: {
								name: 'firstNameEnglish',
								label: 'label.firstNameEnglish',
								required: true,
								disabled: false,
							},
							validation: [{ requierd: true }, { [validationTypes.latinLettersOnly]: true }],
						},
						{
							type: fieldType.text,
							mode: fieldMode.readonly,
							props: {
								name: 'lastNameEnglish',
								label: 'label.lastNameEnglish',
								required: true,
								disabled: false,
							},
							validation: [{ requierd: true }, { [validationTypes.latinLettersOnly]: true }],
						},
					],
				},
				{
					type: fieldsGroupType.row,
					title: 'label.birthDate',
					fields: [
						{
							type: fieldType.select,
							mode: fieldMode.readonly,
							props: {
								name: 'day',
								label: 'label.day',
								options: getAllDays(),
								required: true,
								disabled: false,
							},
							//validation: [{ requierd: true }],
						},
						{
							type: fieldType.select,
							mode: fieldMode.readonly,
							props: {
								name: 'month',
								label: 'label.month',
								options: getAllMonths(),
								required: true,
								disabled: false,
							},
							//validation: [{ requierd: true }],
						},
						{
							type: fieldType.select,
							mode: fieldMode.readonly,
							props: {
								name: 'year',
								label: 'label.year',
								options: getYears(),
								required: true,
								disabled: false,
							},
							//validation: [{ requierd: true }],
						},
					],
				},
				{
					type: fieldsGroupType.row,
					fields: [
						{
							type: fieldType.radio,
							mode: fieldMode.write,
							props: {
								name: 'legalStatus',
								label: 'label.publicFigure',
								options: [
									{ value: ContactLegalStatus.Legal, label: 'label.yes', disabled: false },
									{ value: ContactLegalStatus.NotLegal, label: 'label.no', disabled: false },
								],
								required: true,
								disabled: false,
							},
							//validation: [{ requierd: true }],
						},
					],
				},
				{
					type: fieldsGroupType.row,
					fields: [
						{
							type: fieldType.radio,
							mode: fieldMode.write,
							props: {
								name: 'identificationType',
								label: 'label.identificationType',
								options: [
									{ value: 'ID', label: 'label.identicationId', disabled: false },
									{ value: 'Passport', label: 'label.passport', disabled: false },
								],
								required: true,
								disabled: false,
							},
							//validation: [{ requierd: true }],
						},
					],
				},
				{
					type: fieldsGroupType.col,
					fields: [
						{
							type: fieldType.text,
							mode: fieldMode.readonly,
							props: {
								name: 'identificationNumber',
								label: 'label.identificationNumber',
								required: true,
								disabled: false,
							},
							validation: [
								{ requierd: true },
								{ [validationTypes.digitsOnly]: true },
								{
									[validationTypes.custom]: {
										function: (value: string) => value.length < 10,
										errorText: 'validations.errors.userIdentificationNumber',
									},
								},
							],
						},
					],
				},
				/*
				{
					type: fieldsGroupType.col,
					fields: [
						{
							type: fieldType.radio,
							mode: fieldMode.write,
							props: {
								name: 'gender',
								label: 'label.gender',
								options: [
									{ value: 'Male', label: 'label.male', disabled: false },
									{ value: 'Female', label: 'label.female', disabled: false },
								],
								required: true,
								disabled: false,
							},
							//validation: [{ requierd: true }],
						},
					],
				},
				*/
			],
		},
		{
			name: 'page.managePendingRequests.forms.contact',
			handleChange: () => {},
			fieldsGroups: [
				{
					type: fieldsGroupType.col,
					fields: [
						{
							type: fieldType.text,
							mode: fieldMode.readonly,
							props: {
								name: 'emailAddress',
								label: 'label.email',
								required: true,
								disabled: false,
							},
							validation: [{ requierd: true }, { email: true }],
						},
						{
							type: fieldType.text,
							mode: fieldMode.readonly,
							props: {
								name: 'phoneNumber',
								label: 'label.phone',
								required: true,
								disabled: false,
							},
							validation: [{ requierd: true }, { phone: true }],
						},
						/*
						{
							type: fieldType.text,
							mode: fieldMode.readonly,
							props: {
								name: 'address',
								label: 'label.address',
								required: true,
								disabled: false,
							},
							validation: [{ requierd: true }, { [validationTypes.hebrewLettersSpecialChars]: true }],
						},
						{
							type: fieldType.text,
							mode: fieldMode.readonly,
							props: {
								name: 'city',
								label: 'label.city',
								required: true,
								disabled: false,
							},
							validation: [{ requierd: true }, { [validationTypes.hebrewLettersOnly]: true }],
						},
						{
							type: fieldType.select,
							mode: fieldMode.readonly,
							props: {
								name: 'countryId',
								label: 'label.country',
								required: true,
								disabled: false,
								options: [{ value: countryId, label: 'Israel' }],
							},
							validation: [{ requierd: true }],
						},
						{
							type: fieldType.select,
							mode: fieldMode.readonly,
							props: {
								name: 'birthCountryId',
								label: 'label.birthCountryId',
								required: true,
								disabled: false,
							},
							validation: [{ requierd: true }],
						},
						*/
					],
				},
			],
		},
		{
			name: 'page.managePendingRequests.forms.manageAccountDetails',
			handleChange: () => {},
			fieldsGroups: [
				{
					type: fieldsGroupType.col,
					fields: [
						{
							type: fieldType.text,
							mode: fieldMode.readonly,
							props: {
								name: 'occupation',
								label: 'label.role',
								disabled: false,
							},
							validation: [{ requierd: true }],
						},
						{
							type: fieldType.select,
							mode: fieldMode.readonly,
							props: {
								name: 'permission',
								label: 'label.permisionLevel',
								required: true,
								disabled: false,
							},
							validation: [{ requierd: true }],
						},
						{
							type: fieldType.text,
							mode: fieldMode.readonly,
							props: {
								name: 'maxForPayment',
								label: 'label.maxForPayment',
								disabled: false,
							},
							suffix: '$',
							validation: [{ requierd: true }],
						},
						{
							type: fieldType.text,
							mode: fieldMode.readonly,
							props: {
								name: 'maxForConvert',
								label: 'label.maxForConvert',
								disabled: false,
							},
							suffix: '$',
							validation: [{ requierd: true }],
						},
					],
				},
			],
		},
	],
	[pendingRequestsTypes.BANK_ACCOUNTS]: [
		{
			name: 'page.managePendingRequests.forms.bank',
			handleChange: () => {},
			fieldsGroups: [
				{
					type: fieldsGroupType.col,
					fields: [
						{
							type: fieldType.text,
							mode: fieldMode.readWithEnableWrite,
							props: {
								name: 'accountOwnerName',
								label: 'page.pendingRequests.field.accountOwnerName',
								required: true,
								disabled: false,
							},
							validation: [{ requierd: true }],
						},
						{
							type: fieldType.select,
							mode: fieldMode.readonly,
							props: {
								name: 'bankName.bankCode',
								label: 'page.pendingRequests.field.bankName',
								required: true,
								disabled: false,
							},
							validation: [{ requierd: true }],
						},
						{
							type: fieldType.text,
							mode: fieldMode.readonly,
							props: {
								name: 'bankBranch',
								label: 'page.pendingRequests.field.bankBranch',
								required: true,
								disabled: false,
							},
							validation: [{ requierd: true }],
						},
						{
							type: fieldType.text,
							mode: fieldMode.readWithEnableWrite,
							props: {
								name: 'accountNumber',
								label: 'page.pendingRequests.field.accountNumber',
								required: true,
								disabled: false,
							},
							validation: [{ requierd: true }],
						},
					],
				},
			],
		},
		{
			//name: 'page.managePendingRequests.forms.approveAccount',
			//handleChange: () => {},
			fieldsGroups: [
				{
					type: fieldsGroupType.col,
					fields: [
						{
							type: fieldType.file,
							mode: fieldMode.readWithEnableWrite,
							props: {
								name: 'file',
								disabled: false,
								required: true,
							},
							validation: [{ requierd: true }],
						},
					],
				},
			],
		},
	],
	[pendingRequestsTypes.BENEFICIARIES]: [
		{
			name: 'page.managePendingRequests.forms.beneficiaryDetails',
			handleChange: () => {},
			fieldsGroups: [
				{
					type: fieldsGroupType.col,
					fields: [
						{
							type: fieldType.text,
							mode: fieldMode.readWithEnableWrite,
							props: {
								name: 'type',
								label: 'label.beneficiaryType',
								required: true,
							},
							validation: [{ requierd: true }],
						},
						{
							type: fieldType.text,
							mode: fieldMode.readWithEnableWrite,
							props: {
								name: 'firstName',
								label: 'label.firstName',
								required: true,
							},
							dependency: { name: 'type', value: 'Individual' },
							validation: [{ requierd: true }],
						},
						{
							type: fieldType.text,
							mode: fieldMode.readWithEnableWrite,
							props: {
								name: 'lastName',
								label: 'label.lastName',
								required: true,
							},
							dependency: { name: 'type', value: 'Individual' },
							validation: [{ requierd: true }],
						},
						{
							type: fieldType.text,
							mode: fieldMode.readWithEnableWrite,
							props: {
								name: 'companyName',
								label: 'label.companyName',
								required: true,
							},
							dependency: { name: 'type', value: 'Company' },
							validation: [{ requierd: true }],
						},
						{
							type: fieldType.text,
							mode: fieldMode.readWithEnableWrite,
							props: {
								name: 'nickname',
								label: 'label.nickname',
								required: true,
							},
							validation: [{ requierd: true }],
						},
						{
							type: fieldType.text,
							mode: fieldMode.readWithEnableWrite,
							props: {
								name: 'identificationNumber',
								label: 'label.identificationNumber',
								required: true,
							},
							validation: [{ requierd: true }],
						},
						{
							type: fieldType.text,
							mode: fieldMode.readWithEnableWrite,
							props: {
								name: 'address',
								label: 'label.address',
								required: true,
							},
							validation: [{ requierd: true }],
						},
						{
							type: fieldType.text,
							mode: fieldMode.readWithEnableWrite,
							props: {
								name: 'city',
								label: 'label.city',
								required: true,
							},
							validation: [{ requierd: true }],
						},
						{
							type: fieldType.text,
							mode: fieldMode.readWithEnableWrite,
							props: {
								name: 'country.name',
								label: 'label.country',
								required: true,
							},
							validation: [{ requierd: true }],
						},
					],
				},
			],
		},
		{
			name: 'page.managePendingRequests.forms.bank',
			handleChange: () => {},
			fieldsGroups: [
				{
					type: fieldsGroupType.col,
					fields: [
						{
							type: fieldType.text,
							mode: fieldMode.readWithEnableWrite,
							props: {
								name: 'bankAccountHolderName',
								label: 'label.bankAccountHolderName',
								required: true,
							},
							validation: [{ requierd: true }],
						},
						{
							type: fieldType.text,
							mode: fieldMode.readWithEnableWrite,
							props: {
								name: 'accountNumber',
								label: 'label.accountNumber',
								required: true,
							},
							dependency: { name: 'type', value: 'Individual' },
							validation: [{ requierd: true }],
						},
					],
				},
			],
		},
	],
	[pendingRequestsTypes.GENERAL_SUPPORT]: [],
	[pendingRequestsTypes.WITHDRAWAL_SUPPORT]: [
		{
			fieldsGroups: [
				{
					//type: fieldsGroupType.col,
					fields: [
						{
							type: fieldType.select,
							//mode: fieldMode.readonly,
							props: {
								name: 'approvedBy',
								label: 'page.pendingRequests.balance.field.requester',
								required: true,
								disabled: false,
							},
							validation: [{ requierd: true }],
						},
					],
				},
			],
		},
		{
			name: 'page.pendingRequests.balance.field.transferDetails',
			fieldsGroups: [
				{
					//type: fieldsGroupType.col,
					fields: [
						{
							type: fieldType.text,
							mode: fieldMode.readonly,
							props: {
								name: 'createdAt',
								label: 'page.pendingRequests.balance.field.createdAt',
								required: false,
								disabled: true,
							},
							validation: [{ requierd: false }],
							customValue: (value: any) => format(new Date(), timing.FULLDATE),
						},
						{
							// 	type: fieldType.select,
							// 	mode: fieldMode.readonly,
							props: {
								name: 'currency',
								// 		label: 'page.pendingRequests.balance.field.currency',
								// 		options: [{ label: 'bbbb', value: 'cccc' }],
								required: true,
								disabled: false,
							},
							validation: [{ requierd: true }],
						},
						{
							// 	type: fieldType.text,
							//mode: fieldMode.readonly,
							props: {
								// 		name: 'amount',
								// 		label: 'page.pendingRequests.balance.field.amount',
								// 		required: true,

								disabled: false,
							},
							validation: [{ requierd: true }, { integer: true }],
						},
						{
							// 	type: fieldType.text,
							//mode: fieldMode.readonly,
							props: {
								// 		name: 'amount',
								// 		label: 'page.pendingRequests.balance.field.amount',
								required: true,

								disabled: false,
							},
							//validation: [{ requierd: true }, { integer: true }],
						},
						{
							type: fieldType.select,
							//mode: fieldMode.readonly,
							props: {
								name: 'companyBankAccountId',
								options: [],
								//label: 'page.pendingRequests.balance.field.accountForWithdrawal',
								required: false,
								disabled: false,
							},
							//validation: [],
						},
					],
				},
			],
		},
		{
			name: 'page.pendingRequests.balance.field.confirm.mainTitle',
			hide: true,
			//handleChange: () => {},
			fieldsGroups: [
				{
					//type: fieldsGroupType.col,
					fields: [
						{
							// 	type: fieldType.checkbox,
							props: {
								// 		name: 'approveTitle',
								// 		label: 'page.pendingRequests.balance.field.confirm.title',
								required: false,
								disabled: true,
							},
							validation: [{ checked: true }],
						},
						{
							// 	type: fieldType.label,
							// 	mode: fieldMode.readWithEnableWrite,
							props: {
								// 		name: 'approveSubTitle',
								// 		label: 'page.pendingRequests.balance.field.confirm.subtitle',
								// 		required: false,
								disabled: true,
							},
							// 	validation: [{ requierd: false }],
						},
					],
				},
			],
		},
		{
			name: 'page.pendingRequests.balance.field.bo.confirm.mainTitle',
			//handleChange: () => {},
			fieldsGroups: [
				{
					//type: fieldsGroupType.col,
					fields: [
						/*{
              type: fieldType.label,
              mode: fieldMode.readWithEnableWrite,
              props: {
                name: 'selectApproveTitleNumber',
                label: 'page.pendingRequests.balance.field.bo.confirm.of.two',
                required: false,
                disabled: false,
              },
              validation: [],
            },*/
						{
							type: fieldType.label,
							mode: fieldMode.readWithEnableWrite,
							props: {
								name: 'selectApproveTitle',
								label: 'page.pendingRequests.balance.field.bo.confirm.subtitle',
								required: false,
								disabled: false,
							},
							validation: [],
						},
						{
							type: fieldType.radio,
							mode: fieldMode.write,
							props: {
								name: 'selectApprove',
								label: ' ',
								options: [
									{
										value: 'Approve',
										label: 'label.approved',
										disabled: false,
									},
									{
										value: 'NotApprove',
										label: 'label.notApproved',
										disabled: false,
									},
								],
								required: false,
								disabled: false,
							},
							validation: [{ requierd: true }],
						},
					],
				},
			],
		},
	],
	[pendingRequestsTypes.PAYMENTS]: [
		{
			name: 'page.managePendingRequests.forms.account',
			handleChange: () => {},
			theme: formThemes.hiddenInputs,
			fieldsGroups: [
				{
					type: fieldsGroupType.col,
					fields: [
						{
							type: fieldType.text,
							mode: fieldMode.readWithEnableWrite,
							props: {
								name: 'requestedByCompany.name',
								label: 'label.companyNameHebrew',
							},
							validation: [{ requierd: true }],
						},
						{
							type: fieldType.text,
							mode: fieldMode.readonly,
							props: {
								name: 'requestedByCompany.englishName',
								label: 'label.companyNameEnglish',
							},
							validation: [{ requierd: true }],
						},
						{
							type: fieldType.text,
							mode: fieldMode.readonly,
							props: {
								name: 'firstName',
								label: 'label.firstName',
							},
							validation: [{ requierd: true }],
						},
						{
							type: fieldType.text,
							mode: fieldMode.readonly,
							props: {
								name: 'lastName',
								label: 'label.lastName',
							},
							validation: [{ requierd: true }],
						},
					],
				},
			],
		},
		{
			name: 'page.managePendingRequests.forms.company',
			handleChange: () => {},
			fieldsGroups: [
				{
					type: fieldsGroupType.col,
					fields: [
						{
							type: fieldType.text,
							mode: fieldMode.readonly,
							props: {
								name: 'role',
								label: 'label.role',
							},
							validation: [{ requierd: true }],
						},
						{
							type: fieldType.text,
							mode: fieldMode.readonly,
							props: {
								name: 'legalStatus',
								label: 'label.legalStatus',
							},
							validation: [{ requierd: true }],
						},
						{
							type: fieldType.text,
							mode: fieldMode.readonly,
							props: {
								name: 'identificationType',
								label: 'label.identificationType',
							},
							validation: [{ requierd: true }],
						},
						{
							type: fieldType.text,
							mode: fieldMode.readonly,
							props: {
								name: 'identificationNumber',
								label: 'label.identificationNumber',
							},
							validation: [{ requierd: true }],
						},
						{
							type: fieldType.text,
							mode: fieldMode.readonly,
							props: {
								name: 'gender',
								label: 'label.gender',
							},
							validation: [{ requierd: true }],
						},
						{
							type: fieldType.text,
							mode: fieldMode.readonly,
							props: {
								name: 'requestedByCompany.maxForPayment',
								label: 'label.maxForPayment',
							},
							suffix: '$',
							validation: [{ requierd: true }],
						},
						{
							type: fieldType.text,
							mode: fieldMode.readonly,
							props: {
								name: 'requestedByCompany.maxForConvert',
								label: 'label.maxForConvert',
							},
							suffix: '$',
							validation: [{ requierd: true }],
						},
					],
				},
			],
		},
		{
			name: 'page.managePendingRequests.forms.contact',
			handleChange: () => {},
			fieldsGroups: [
				{
					type: fieldsGroupType.col,
					fields: [
						{
							type: fieldType.text,
							mode: fieldMode.readonly,
							props: {
								name: 'email',
								label: 'label.email',
							},
							validation: [{ requierd: true }],
						},
						{
							type: fieldType.text,
							mode: fieldMode.readonly,
							props: {
								name: 'phone',
								label: 'label.phone',
							},
							validation: [{ requierd: true }],
						},
					],
				},
			],
		},
		{
			name: 'page.managePendingRequests.forms.address',
			handleChange: () => {},
			fieldsGroups: [
				{
					type: fieldsGroupType.col,
					fields: [
						{
							type: fieldType.text,
							mode: fieldMode.readonly,
							props: {
								name: 'address',
								label: 'label.address',
							},
							validation: [{ requierd: true }],
						},
						{
							type: fieldType.text,
							mode: fieldMode.readonly,
							props: {
								name: 'city',
								label: 'label.city',
							},
							validation: [{ requierd: true }],
						},
						{
							type: fieldType.text,
							mode: fieldMode.readonly,
							props: {
								name: 'country.name',
								label: 'label.country',
							},
							validation: [{ requierd: true }],
						},
					],
				},
			],
		},
	],
};
